import * as React from 'react';

const Envelope = ({ ...props }) => (
    <svg
        width="16"
        height="24"
        viewBox="0 0 16 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M0 6V17H16V6H0ZM14.44 7.4L8 10.45L1.56 7.4H14.44ZM14.6 15.6H1.4V8.87L8 12L14.6 8.87V15.6Z"
            fill="currentColor"
        />
    </svg>
);

export default Envelope;
